<app-main-contents>
  <app-breadcrumbs [label2]="title"></app-breadcrumbs>
  <app-title [title]="title"></app-title>
  <app-sending *ngIf="sending"></app-sending>
  <div class="flex">
    <app-select
      style="width: 800px"
      *ngIf="actuateOptions.length > 1"
      [options]="actuateOptions"
      [(ngModel)]="selectedActuateCd"
      (change)="selectActuate(selectedActuateCd)"
    ></app-select>
    <div *ngIf="periods.length">
      <div class="period_select">
        <app-select
          [options]="periods"
          [(ngModel)]="selectedFilePath"
          (change)="selectPeriod(selectedFilePath)"
        ></app-select>
      </div>
    </div>
    <div class="download-btn" *ngIf="selectedFilePath">
      <div class="c-btns__item" style="text-align: right">
        <a (click)="download()" class="c-btn c-btn--s" style="cursor: pointer"
          ><span>PDFダウンロード</span></a
        >
      </div>
    </div>
  </div>

  <div *ngIf="fileUrl" class="c-pdf h-margin--t16">
    <iframe [src]="fileUrl"> </iframe>
  </div>

  <div *ngIf="!periods.length && selectedActuateCd && !loading">
    まだ登録がありません
  </div>
</app-main-contents>
